import { useCallback } from 'react';
import { logout as apiLogout } from '@/services/rbac-auth.service';
import { useAuthStore } from '@/stores/auth.store';
import { ROUTES } from '@/constants';

/** Cierra sesión RBAC: revoca cookie en el backend, limpia el store y va a login. */
export function useLogout(): () => Promise<void> {
  return useCallback(async () => {
    try { await apiLogout(); } catch { /* limpiamos igual */ }
    useAuthStore.getState().clearAuth();
    window.location.href = ROUTES.LOGIN;
  }, []);
}
